/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useCertificateStore } from "../stores/certificateStore";
import { Link } from "react-router-dom";
import Logo from "../assets/NWLogo.png"
import FullLogo from "../assets/Logo.svg"
import CertificateText from "../components/Icons/CertificateText";
import Button from "../components/Shared/Button";
import generatePDF from "react-to-pdf";

import { Helmet } from "react-helmet";
import Spinner from "../components/Shared/Spinner";

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleString("default", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const Certificate = () => {
  const { certificateData } = useCertificateStore();

  const options = {
    method: "save",
    filename: "AAA - Certificate",
    page: {
      format: "junior-legal",
      orientation: "landscape",
    },
    canvas: {
      mimeType: "image/jpeg",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
      canvas: {
        useCORS: true,
      },
    },
  };

  const getTargetElement = () => document.getElementById("content-id");

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.nilewisect.com/certificate" />
      </Helmet>
      {certificateData ? (
        <>
          <div className="pt-12 xl:block hidden">
            <div
              id="content-id"
              className="flex items-center justify-center pt-28 pb-20"
            >
              <div className="w-full max-w-5xl mx-auto relative">
                <div className="absolute -top-12 -left-10 border-t-[24px] border-l-[24px] max-w-[436px] max-h-[436px] border-primary h-full w-full"></div>
                <div className="absolute -bottom-12 -right-10 border-b-[24px] border-r-[24px] max-w-[436px] max-h-[436px] border-primary h-full w-full"></div>
                <div className="w-full h-full">
                  <div className="border-[3px] border-secondary rounded w-full h-full pb-10 pt-12 px-8 flex flex-col items-center">
                    <Link
                      to="/"
                      className="flex items-center gap-1.5 md:justify-center justify-center md:border-b-0 border-b border-black/15 mb-1"
                    >
                      <img src={Logo} className="w-20 h-auto" />
                      <span className="text-secondary font-bold md:text-2xl text-lg">
                        NileWise
                      </span>
                    </Link>
                    <CertificateText />
                    <h1 className="text-center font-ruqaa text-2xl mt-7">
                      This is to certify that
                    </h1>
                    <div className="font-artifika w-full">
                      <h1 className="text-center text-[45px] mt-5 text-[#112798] leading-none">
                        {certificateData?.student.firstName}{" "}
                        {certificateData?.student.lastName}
                      </h1>
                      <div className="w-full bg-black h-[3px] mt-5"></div>
                    </div>
                    <p className="font-artifika text-2xl max-w-[820px] text-center mt-7 capitalize">
                      has successfully completed the
                      <br /> {certificateData?.courseName}
                      <br /> conducted by NileWise Consulting & Training from{" "}
                      {formatDate(certificateData?.from || "")} to{" "}
                      {formatDate(certificateData?.to || "")}.
                    </p>
                    <div className="pt-24 flex justify-between w-full">
                      <div className="font-artifika text-center border-t-[1.5px] pt-2.5 border-black">
                        <p>
                          NileWise
                          <br />
                          Empowering your accounting skills
                          <br />
                          for a brighter future
                        </p>
                      </div>
                      <div className="font-artifika text-center border-t-[1.5px] pt-2.5 border-black">
                        <p>
                          <span className="font-script text-primary text-2xl">
                            Dr. {certificateData?.instructor.firstName}{" "}
                            {certificateData?.instructor.lastName}
                          </span>
                          <br />
                          Dept. of Accounting
                          <br />
                          Alexandria University
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center pb-20">
              <h1 className="font-bold text-3xl mb-5">
                Congratulations on finishing the course 🥳🎊🎉
              </h1>

              <Button
                //@ts-expect-error
                onClick={() => generatePDF(getTargetElement, options)}
                variant="primary"
                className="!rounded-none w-80"
              >
                Download your certificate
              </Button>
            </div>
          </div>
          <div className="xl:hidden h-screen bg-white flex flex-col items-center justify-center">
            <div className="text-center container md:mb-20 mb-[60px] text-primary">
              <Link
                to="/"
                className="flex items-center gap-1.5 justify-center mb-3"
              >
                      <img src={FullLogo} className="md:w-auto w-40" />
              </Link>
              <h1 className="font-bold md:text-3xl text-xl mb-5">
                Congratulations on surpassing the course 🥳🎊🎉
              </h1>
              <p className="">
                Note: Please use PC or Laptop to be able to print your
                certificate 😄😄
              </p>
            </div>
          </div>
        </>
      ) : (
        <div className="h-screen flex items-center justify-center">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default Certificate;
